import {
  Card,
  CardBody,
  CardHeader,
  HStack,
  Image,
  Text,
} from '@chakra-ui/react';
import warningInfoIcon from '../../../assets/images/icons/warning_info.svg';
import { theme } from '../../../shared/theme';
import { useFlag } from '@unleash/proxy-client-react';
import { FeatureFlag } from '../../../constant/feature-flags';
import { AttentionNeededMessage, SyncingFailuresMessage } from './Messages';
import { NeedsAttentionBanner } from './NeedsAttentionBanner';

type ConnectionAttentionBannerProps = {
  attentionNeededCount: number;
  syncingFailuresCount: number;
  onClickAttentionNeeded: React.MouseEventHandler<HTMLAnchorElement>;
  onClickSyncingFailures: React.MouseEventHandler<HTMLAnchorElement>;
  fullWidth?: boolean;
};

export const ConnectionAttentionBanner = (
  props: ConnectionAttentionBannerProps,
): JSX.Element | null => {
  const {
    attentionNeededCount,
    syncingFailuresCount,
    onClickAttentionNeeded,
    onClickSyncingFailures,
    fullWidth,
  } = props;
  const isConnectionStatusAccuracyUIEnabled = useFlag(
    FeatureFlag.ConnectionStatusAccuracyUI,
  );

  if (!isConnectionStatusAccuracyUIEnabled) {
    return (
      <NeedsAttentionBanner
        connectionCount={attentionNeededCount}
        onClick={onClickAttentionNeeded}
        fullWidth={fullWidth}
      />
    );
  }

  if (!attentionNeededCount && !syncingFailuresCount) return null;

  return (
    <Card
      boxShadow="none"
      border={`1px solid ${theme.colors.warning[200]}`}
      borderRadius="8px"
      fontSize="13px"
      fontWeight="500"
      lineHeight="24px"
    >
      <CardHeader
        backgroundColor={theme.colors.warning[50]}
        color={theme.colors.warning[700]}
        borderRadius="8px"
        padding="8px 16px"
      >
        <HStack spacing="4px">
          <Image src={warningInfoIcon} />
          <Text>Connection Information</Text>
        </HStack>
      </CardHeader>
      <CardBody padding="8px 16px">
        <AttentionNeededMessage
          connectionCount={attentionNeededCount}
          onClick={onClickAttentionNeeded}
        />
        <SyncingFailuresMessage
          connectionCount={syncingFailuresCount}
          onClick={onClickSyncingFailures}
        />
      </CardBody>
    </Card>
  );
};

export * from './connectionFilters';
